/* Ocean Racing cart drawer helpers (ntd-cart.js), 2026-10-06.
   1. Second-pair swap: one atomic /cart/update.js call moves a One pair line to the matching Two pair variant,
      with Dawn's sections render so the drawer re-renders in place. Listeners are delegated on document because
      Dawn replaces the drawer nodes on every update.
   2. Popup hide: while the drawer is open, body.ntd-cart-open is set and ntd-cart.css hides the Klaviyo form. */
(function () {
  if (window.__ntdCartInit) return;
  window.__ntdCartInit = true;

  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() {
    var d = drawer();
    return d && typeof d.getSectionsToRender === 'function' ? d.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ntd-swap-from]');
    if (!btn) return;
    e.preventDefault();
    var from = btn.getAttribute('data-ntd-swap-from');
    var to = btn.getAttribute('data-ntd-swap-to');
    var qty = parseInt(btn.getAttribute('data-ntd-swap-qty'), 10) || 1;
    btn.disabled = true;
    fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (cart) {
      var existingTwo = 0;
      cart.items.forEach(function (i) { if (String(i.variant_id) === String(to)) existingTwo += i.quantity; });
      var updates = {};
      updates[from] = 0;
      updates[to] = existingTwo + qty;
      return fetch(window.routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ updates: updates, sections: sectionIds(), sections_url: window.location.pathname }),
      });
    }).then(function (r) { return r.json(); }).then(function (state) {
      var d = drawer();
      if (state && state.sections && d && typeof d.renderContents === 'function') {
        d.renderContents(state);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ntd-cart', cartData: state });
      } else {
        window.location.reload();
      }
    }).catch(function () { btn.disabled = false; });
  });

  /* popup hide while the drawer is open */
  function watch() {
    var d = drawer();
    if (!d || d.__ntdWatched) return;
    d.__ntdWatched = true;
    var sync = function () { document.body.classList.toggle('ntd-cart-open', d.classList.contains('active')); };
    new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['class'] });
    sync();
  }
  watch();
  document.addEventListener('DOMContentLoaded', watch);
})();
